import { createSlice } from "@reduxjs/toolkit";

const defaultNewPersonalPromptModel = require("../model/defaultNewPersonalPromptModel.js");
const defaultNewPersonalPrompt = defaultNewPersonalPromptModel.DefaultNewPersonalPromptModel;

const defaultNewCentralPromptModel = require("../model/defaultNewCentralPromptModel.js");
const defaultNewCentralPrompt = defaultNewCentralPromptModel.DefaultNewCentralPromptModel;

const promptSlice = createSlice ({
    name: "prompt",
    
    initialState: {
        references: [], 
        personalPrompts: [],
        tableTypes: null,
        systemPromptsClient: {},
        systemPromptsTest : {},
        defaultNewPersonalPrompt: JSON.parse(JSON.stringify(defaultNewPersonalPrompt)),
        newPersonalPrompt: JSON.parse(JSON.stringify(defaultNewPersonalPrompt)),
        defaultNewCentralPrompt: JSON.parse(JSON.stringify(defaultNewCentralPrompt)),
        newCentralPrompt: JSON.parse(JSON.stringify(defaultNewCentralPrompt)),
        isValidationErrorOnAddNewPrompt: false,
        selectedCentralPrompt: null,
        selectedPersonalPrompt: null
    },

    reducers: {
        setReferences: (state, action) => {
            state.references = action.payload;
        },
        setPersonalPrompts: (state, action) => {
            state.personalPrompts = action.payload.personalPrompts
        },

        setTableTypes: (state, action) => {
            state.tableTypes = action.payload.tableTypes
        },

        setSystemPromptsClient: (state, action) => {
            state.systemPromptsClient = action.payload.systemPromptsClient
        },

        setSystemPromptsTest: (state, action) => {
            state.systemPromptsTest = action.payload.systemPromptsTest
        },

        resetNewPersonalPrompt: (state, action) => {
            state.newPersonalPrompt = action.payload.newPersonalPrompt
        },

        setNewPersonalPromptName: (state, action) => {
            state.newPersonalPrompt.promptName = action.payload.promptName
        },

        setNewPersonalTableType: (state, action) => {
            state.newPersonalPrompt.tableType = action.payload.tableType
        },

        setNewPersonalPrompts: (state, action) => {
            state.newPersonalPrompt.prompts = action.payload.prompts
        },

        setIsValidationErrorOnAddNewPrompt: (state, action) => {
            state.isValidationErrorOnAddNewPrompt = action.payload.isValidationErrorOnAddNewPrompt
        },

        resetNewCentralPrompt: (state, action) => {
            state.newCentralPrompt = action.payload.newCentralPrompt
        },

        setNewCentralPromptName: (state, action) => {
            state.newCentralPrompt.promptName = action.payload.promptName
        },

        setNewCentralTableType: (state, action) => {
            state.newCentralPrompt.tableType = action.payload.tableType
        },

        setNewCentralPrompts: (state, action) => {
            state.newCentralPrompt.prompts = action.payload.prompts
        },

        setSelectedCentralPrompt: (state, action) => {
            state.selectedCentralPrompt = action.payload.selectedCentralPrompt
        },
    
        setSelectedPersonalPrompt: (state, action) => {
            state.selectedPersonalPrompt = action.payload.selectedPersonalPrompt
        }

    }
})

export const { 
    setPersonalPrompts,
    resetNewPersonalPrompt,
    setNewPersonalPromptName,
    setNewPersonalTableType,
    setNewPersonalPrompts,
    setTableTypes,
    resetNewCentralPrompt,
    setNewCentralPromptName,
    setNewCentralTableType,
    setNewCentralPrompts,
    setIsValidationErrorOnAddNewPrompt,
    setSelectedCentralPrompt,
    setSelectedPersonalPrompt,
    setReferences 
} = promptSlice.actions;
export const { setSystemPromptsClient, setSystemPromptsTest } = promptSlice.actions;


export default promptSlice.reducer;